export default __webpack_public_path__ + "static/media/tag.ca2b17cc.svg";